// src/directives/trim-input.js
export default {
	mounted(el, binding) {
		applyEmailSanitizer(el, binding)
	},
	updated(el, binding) {
		applyEmailSanitizer(el, binding)
	},
}

function applyEmailSanitizer(el, binding) {
	if (el._trimInputApplied) return

	const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
	if (!input) return

	const blurOnly = binding.modifiers && binding.modifiers.blurOnly

	// Remove espaços durante a digitação apenas se NÃO for blurOnly
	if (!blurOnly) {
		input.addEventListener('input', () => {
			if (input.value.includes(' ')) {
				input.value = input.value.replace(/\s+/g, '')
				input.dispatchEvent(new Event('input')) // notifica o v-model
			}
		})
	}

	// Remove espaços extras ao sair do campo
	input.addEventListener('blur', () => {
		const trimmedValue = input.value.trim()
		if (input.value !== trimmedValue) {
			input.value = trimmedValue
			input.dispatchEvent(new Event('input'))
		}
	})

	el._trimInputApplied = true
}
